import React from "react";

import { InternalLink } from "../../../../../shared/components/design-system/Button/Link";
import Icon from "../../../../../shared/components/design-system/Icon";
import Card from "../Card";
import styles from "./index.module.scss";

export type LinkCardProps = { to: string; text: string };

export default function LinkCard({ to, text }: LinkCardProps) {
  return (
    <InternalLink to={to} className={styles.CardLink}>
      <Card>
        <span>{text}</span>
        <Icon icon="chevronRight" />
      </Card>
    </InternalLink>
  );
}
